// 添加动态路由
export function addDynamicsRouter(router, menus) {
    const dynamicsRouteList = buildTreeRouter(menus)
    let layoutRoute = {
        name: 'layout_dynamics',
        component: () => import('@/layout/index.vue'),
        children: dynamicsRouteList,
    }
    // 删除旧路由，添加新路由
    if (router.hasRoute('layout_dynamics')) {
        router.removeRoute('layout_dynamics')
    }
    router.addRoute(layoutRoute)

    return router
}

// 创建树形路由数据
export function buildTreeRouter(menus) {
    let list = []
    menus.forEach((item) => {
        let temp = {
            name: item.name,
            path: item.path,
            meta: item.meta,
        }
        if (item.pageUrl) {
            temp.component = loadView(item.pageUrl);
        }
        if (item.children && item.children.length > 0) {
            temp.children = buildTreeRouter(item.children)
        }
        list.push(temp)
    })
    return list
}

// 静态import作为回退方案
function loadView(view) {
    view = view.replace('/', "")
    return () => import(`@/views/${view}.vue`);
}
